/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRoomMatchGroupsResponsePagination
 */
export interface GetRoomMatchGroupsResponsePagination {
    /**
     * Current page number
     * @type {number}
     * @memberof GetRoomMatchGroupsResponsePagination
     */
    page: number;
    /**
     * Items per page
     * @type {number}
     * @memberof GetRoomMatchGroupsResponsePagination
     */
    limit: number;
    /**
     * Total number of room match groups
     * @type {number}
     * @memberof GetRoomMatchGroupsResponsePagination
     */
    total: number;
    /**
     * Whether there are more pages available
     * @type {boolean}
     * @memberof GetRoomMatchGroupsResponsePagination
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the GetRoomMatchGroupsResponsePagination interface.
 */
export function instanceOfGetRoomMatchGroupsResponsePagination(value: object): value is GetRoomMatchGroupsResponsePagination {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function GetRoomMatchGroupsResponsePaginationFromJSON(json: any): GetRoomMatchGroupsResponsePagination {
    return GetRoomMatchGroupsResponsePaginationFromJSONTyped(json, false);
}

export function GetRoomMatchGroupsResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRoomMatchGroupsResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'hasMore': json['hasMore'],
    };
}

export function GetRoomMatchGroupsResponsePaginationToJSON(json: any): GetRoomMatchGroupsResponsePagination {
    return GetRoomMatchGroupsResponsePaginationToJSONTyped(json, false);
}

export function GetRoomMatchGroupsResponsePaginationToJSONTyped(value?: GetRoomMatchGroupsResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'limit': value['limit'],
        'total': value['total'],
        'hasMore': value['hasMore'],
    };
}

